import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import * as padStart from 'lodash/padStart';
import { AirportNavaid, NavaidType } from '../models/airport-navaid.model';
import { isNumeric } from '../../util/helpers';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditNavaidComponent } from '../edit-navaid/edit-navaid.component';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { DeleteNavaidComponent } from '../delete-navaid/delete-navaid.component';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { Source } from '../../shared/models/source.model';
var NavaidComponent = /** @class */ (function () {
    function NavaidComponent(_toggleService, _editNavaidDialog, _deleteNavaidDialog, _snackBar, _businessManagerService) {
        this._toggleService = _toggleService;
        this._editNavaidDialog = _editNavaidDialog;
        this._deleteNavaidDialog = _deleteNavaidDialog;
        this._snackBar = _snackBar;
        this._businessManagerService = _businessManagerService;
        this.navaidDeleted = new EventEmitter();
    }
    NavaidComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.editModeSet = this._toggleService.getState();
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        this.isIslandSource = this.navaid.sourceId === Source.CaribbeanGuide || this.navaid.sourceId === Source.BahamasGuide;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(NavaidComponent.prototype, "bearing", {
        /**
         * Returns formatted bearing from navaid to airport
         */
        get: function () {
            return isNumeric(this.navaid.radial) ? padStart(this.navaid.radial, 3, '0') : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavaidComponent.prototype, "icon", {
        /**
         * Returns the icon to use for the navaid
         * @returns {string}
         */
        get: function () {
            switch (this.navaid.type) {
                case NavaidType.VOR:
                    return 'navaids:vor';
                case NavaidType.NDB:
                case NavaidType.MarineNDB:
                    return 'navaids:ndb';
                case NavaidType.NDB_DME:
                    return 'navaids:ndb-dme';
                case NavaidType.VOR_DME:
                    return 'navaids:vor-dme';
                case NavaidType.VORTAC:
                    return 'navaids:vortac';
                case NavaidType.VOT:
                    return 'navaids:vot';
                default:
                    return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NavaidComponent.prototype, "type", {
        /**
         * Returns formatted navaid type
         */
        get: function () {
            return AirportNavaid.formatNavaidType(this.navaid.type);
        },
        enumerable: true,
        configurable: true
    });
    NavaidComponent.prototype.openEditNavaidDialog = function (navaid) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        var dialogRef = this._editNavaidDialog.open(EditNavaidComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                isNew: false,
                navaid: navaid
            }
        });
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            if (isUpdated.success) {
                _this._snackBar.open('Navaid', 'Updated', {
                    duration: 2000
                });
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    NavaidComponent.prototype.deleteNavaid = function (navaid) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            navaidId: navaid.navaidId
        };
        var dialogRef = this._deleteNavaidDialog.open(DeleteNavaidComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.navaidDeleted.emit(navaid.navaidId);
                _this._snackBar.open('Navaid', 'Deleted', {
                    duration: 2000
                });
            }
            else {
                if (isUpdated.error != null) {
                    ERROR_MSG = isUpdated.error.message;
                }
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return NavaidComponent;
}());
export { NavaidComponent };
